import Alpine from 'alpinejs';
import type { EmblaCarouselType } from 'embla-carousel';
import EmblaCarousel from 'embla-carousel';

type CarouselData = {
  canPrev: boolean;
  canNext: boolean;
  init(this: CarouselData & { $refs: { viewport: HTMLElement } }): void;
  prev(): void;
  next(): void;
  destroy(): void;
};

export const registerCarousel = (): void => {
  Alpine.data('carousel', (): CarouselData => {
    let embla: EmblaCarouselType | undefined;

    return {
      canPrev: false,
      canNext: false,

      init() {
        const api = EmblaCarousel(this.$refs.viewport, {
          loop: false,
          align: 'start',
        });
        embla = api;

        const update = (): void => {
          this.canPrev = api.canScrollPrev();
          this.canNext = api.canScrollNext();
        };

        api.on('select', update);
        api.on('reInit', update);
        update();
      },

      prev() {
        embla?.scrollPrev();
      },

      next() {
        embla?.scrollNext();
      },

      destroy() {
        embla?.destroy();
        embla = undefined;
      },
    };
  });
};
